import { i, s, x } from '../../lit-element.js';
import { o } from '../../class-map.js';
import { reset } from '../../styles/reset.style.js';
import { links } from '../../styles/links.style.js';
import '../../directive.js';

const style = i`
  :host {
    display: inline;
    font-size: 1em;
  }

  :host([single-line]) {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  a.with-icon {
    vertical-align: middle;
  }
`;

class RefiTooltip extends s {
  constructor() {
    super();
    this.iconSize = '1em';
  }

  static get properties() {
    return {
      iconSize: { type: String, attribute: 'icon-size' },
      linkText: { type: String, attribute: 'link-text' },
      name: { type: String, attribute: true },
      showModal: { type: Boolean },
      singleLine: { type: Boolean, attribute: 'single-line' },
      withIcon: { type: Boolean, attribute: 'with-icon' },
      ariaLabelledBy: { type: String, attribute: 'aria-labelled-by' },
      ariaLabel: { type: String, attribute: 'dialog-label', reflect: true },
    };
  }

  static get styles() {
    return [reset, links, style];
  }

  render() {
    return x`
      <a
        href="#"
        class="grv-link ${o({ 'with-icon': this.withIcon })}"
        part="tooltip-link"
        @click="${this.openModal}"
        data-track="${this.name} tooltip"
        role="button"
        aria-label="Click here for more information about ${this.name}"
      >
        ${this.linkText ? x`<span>${this.linkText}</span>` : ''}
        ${this.withIcon
          ? x`
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this.iconSize}" height="${this.iconSize}" fill="#141414">
                <path
                  d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 19a9 9 0 1 1 9-9 9.011 9.011 0 0 1-9 9zm3-4.5a.5.5 0 0 1-.5.5H10a.5.5 0 0 1 0-1h2v-6h-1.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5V16h1.5a.5.5 0 0 1 .5.5zM11.25 7a.75.75 0 1 1 .75.75.75.75 0 0 1-.75-.75z"
                />
              </svg>
            `
          : ''}
      </a>
      <refi-common-modal ?active="${this.showModal}" modal-title="${this.ariaLabelledBy}" @close-modal="${this.closeModal}" modal-label="${this.ariaLabel}">
        <slot></slot>
      </refi-common-modal>
    `;
  }

  firstUpdated() {
    this.tooltipLink = this.shadowRoot.querySelector('.grv-link');
  }

  openModal(ev) {
    ev.preventDefault();
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.tooltipLink.focus();
  }
}

export { RefiTooltip };
